import styled, { css } from 'styled-components';
import { min } from '../../../theme/breakpoints';

interface ITitleWrapperProps {
  as: any;
  hasAltColor?: boolean;
  uppercase: boolean;
  textAlign: string;
}

export const TitleWrapper = styled.a<ITitleWrapperProps>`
  line-height: 1;
  font-family: ${({ theme }) => theme.fonts.secondary.bold};
  margin: 0;
  padding: 0;
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'initial')};
  text-align: center;

  @media screen and ${min('largeTablet')} {
    text-align: ${({ textAlign }) => textAlign};
  }
  ${({ as, theme }) =>
    as === 'h1'
      ? css`
          font-size: 1.875rem;

          @media screen and ${min('tablet')} {
            font-size: 1.75rem;
          }
          @media screen and ${min('largeTablet')} {
            font-size: 3.4375rem;
          }
        `
      : as === 'h2'
      ? css`
          font-size: 1.75rem;

          @media screen and ${min('largeTablet')} {
            font-size: 3.5rem;
          }
          sup {
            position: relative;
            font-family: ${theme.fonts.secondary.light};
            top: -0.2rem;
            vertical-align: 0.2em;
            font-size: 1rem;

            @media screen and ${min('largeTablet')} {
              top: -0.5rem;
              vertical-align: 0.5em;
              font-size: 1.5rem;
            }
          }
        `
      : css`
          font-size: 1.25rem;

          @media screen and ${min('tablet')} {
            font-size: 1.375rem;
          }
          @media screen and ${min('desktop')} {
            font-size: 1.5rem;
          }
        `};

  span {
    color: ${({ theme, hasAltColor }) => (hasAltColor ? theme.colors.HavelockBlue : theme.colors.Carnation)};
  }
`;
